module.exports = __webpack_public_path__ + "static/media/weatherNew.742530b3.png";